import { CalculationRangeResponse } from "../../../../../configuration/calculation-range/models";

const iconsOfActionsList = [
  {
    icon: "trash",
    tooltip: "Eliminar",
  }
];

export const calculationRange = {
  searchText: 'Buscar ...',
  export: false,
  checkbox: true,
  disabled: false,
  dialogHability: true,
  filter: false,
  sort: false,
  paginator: true,
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: CalculationRangeResponse, selection: CalculationRangeResponse[]) => {
    if (selection && selection.length > 0 && row && selection[0].id) {
      return !(selection.length === 1 && row.id === selection[0].id);
    } else if (row.isGeneric) {
      return true;
    } else {
      return !row.id;
    }
  },
  columns: [
    {
      title: "Tipo de origen",
      name: "entityType",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.entityType || "-",
    },
    {
      title: "Modalidad de entrega",
      name: "dispatchMode",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.dispatchMode || "-",
    },
    {
      title: "Tipo de despacho",
      name: "dispatchType",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.dispatchType || "-",
    },
    {
      title: "Tipo de mercadería",
      name: "saleChannel",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => element.saleChannel || "-",
    },
    {
      title: "Días para cálculo de capacidad",
      name: "daysToCalculateCapacity",
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: any) => (element.daysToCalculateCapacity != null ? element.daysToCalculateCapacity : "-"),
    }
  ]
};
